export default [
  {
    path: '/liveview/',
    name: 'Liveview',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve() {
        const url = `${window.location.protocol}//${window.location.host}/liveview-2/`
        window.location.href = url
      },
    },
  },
]
